/**
 * Navigation Module
 *
 */

import { Constants, MQ } from "../helpers/constants.js";
import { AnchorScroll } from "./AnchorScroll.js";

//------------------------------------------------------------------------------------------------------------------
// ::: CONSTANTS
//------------------------------------------------------------------------------------------------------------------

//------------------------------------------------------------------------------------------------------------------
// ::: PUBLIC VARIABLES
//------------------------------------------------------------------------------------------------------------------

//------------------------------------------------------------------------------------------------------------------
// ::: PRIVATE VARIABLES
//------------------------------------------------------------------------------------------------------------------

//------------------------------------------------------------------------------------------------------------------
// ::: GETTERS & SETTERS
//------------------------------------------------------------------------------------------------------------------

//------------------------------------------------------------------------------------------------------------------
// ::: PUBLIC FUNCTIONS
//------------------------------------------------------------------------------------------------------------------

const Navigation = {
    vars: {
        $window: null,
        $body: null,
        lastScrollPosition: 0,
        scrollDirection: null,
        isMobile: null,
        scrollTop: null,
        lockMobileMenu: false,
        anchorTarget: null,
    },
    init: function () {
        Navigation.vars.$window = $(window);
        Navigation.vars.$body = $("body");
        Navigation.events.updateScrollDirection();

        Navigation.vars.isMobile = MQ.LG.matches ? false : true;
        Navigation.sideNavColors();
        Navigation.activeSection();
        Navigation.bindEvents();
        Navigation.sideNavScroll();
    },
    activeSection: function () {
        //highlight in main nav which page/section the user is on
        //there are sections that are not
        const normalizePath = function (path) {
            if (!path) {
                return "/";
            }

            return path.length > 1 && path.endsWith("/")
                ? path.slice(0, -1)
                : path;
        };
        const currentPage = normalizePath(window.location.pathname);
        let hasActiveMenuLink = false;

        $(
            ".menu_set a[href], .primary_nav_wrap-mobile .menu-wrap a[href]"
        ).each(function () {
            const href = this.getAttribute("href");

            if (!href || href.startsWith("#")) {
                return;
            }

            const linkPath = normalizePath(
                new URL(this.href, window.location.origin).pathname
            );

            if (linkPath === currentPage) {
                $(this).parents("li").addClass("active_page");
                hasActiveMenuLink = true;
            }
        });

        if (!hasActiveMenuLink) {
            var sectionClass = "";
            for (var i = 0; i < document.body.classList.length; i++) {
                if (document.body.classList.item(i).indexOf("section") > -1) {
                    sectionClass = document.body.classList.item(i);
                }
            }
            if (sectionClass !== "") {
                $(".menu a." + sectionClass)
                    .parents("li")
                    .addClass("active_page");
            }
        }
    },
    // TO DO: Remove This should no longer be needed in v2
    sideNavColors: function () {
        if ($("#efficacy").length > 0 || $("#adverse-reactions").length > 0) {
            //console.log('SideNavColors');
            //get color for side nav in mobile
            let heading = null;

            if ($("#efficacy").length > 0) {
                // TODO: This element might not exist anymore
                heading = document.querySelector(".efficacy-heading");
            } else if ($("#adverse-reactions").length > 0) {
                heading = document.querySelector(".header_2.safety");
            }

            //console.log(heading);
            if (heading) {
                const classes = heading.classList;

                for (let i = 0; i < classes.length; i++) {
                    if (
                        classes[i] !== "safety" &&
                        classes[i] !== "efficacy-heading" &&
                        classes[i] !== "header_2"
                    ) {
                        if (
                            $(
                                ".side-nav .section-subLinks > .active a"
                            ).text() !== "AFFIRM Trial"
                        ) {
                            $(
                                ".side-nav .section-subLinks > .active a"
                            ).addClass(classes[i]);
                        } else {
                            $(
                                ".side-nav .section-subLinks > .active a"
                            ).addClass("dark_grey");
                        }
                        break;
                    }
                }
            }
        }
    },

    // TO DO: Remove This should no longer be needed in v2
    sideNavScroll: function () {
        //set up scrollspy for side nav sections that require it
        const mod = 20;

        if (
            ($(".side-nav .hasTertiary").length > 0 ||
                $(".side-nav .section.active").length > 0) &&
            $(".strip-text").length > 0
        ) {
            if ($(".side-nav .hasTertiary").length > 0) {
                $(".side-nav .hasTertiary .section-tertiaryLinks").addClass(
                    "nav"
                );
                console.log("tertiary sublinks");
                $("body")
                    .first()
                    .scrollspy({
                        target: ".side-nav .hasTertiary",
                        offset: $(".primary_nav_wrap").innerHeight() + mod,
                    });

                const observer = new MutationObserver(function (
                    mutationsList,
                    observer
                ) {
                    for (var i = 0; i < mutationsList.length; i++) {
                        if (
                            mutationsList[i].type === "attributes" &&
                            mutationsList[i].attributeName === "class"
                        ) {
                            if (
                                $(".section-tertiaryLinks li.active").length <=
                                0
                            ) {
                                $(
                                    ".section-tertiaryLinks li:first-child"
                                ).addClass("active");
                            }
                        }
                    }
                });

                observer.observe(
                    document.querySelector(".section-tertiaryLinks"),
                    {
                        attributes: true,
                        childList: true,
                        subtree: true,
                    }
                );
            } else {
                console.log("section sublinks");
                $(".side-nav .section.active .section-subLinks").addClass(
                    "nav"
                );
                $("body")
                    .first()
                    .scrollspy({
                        target: ".side-nav .section.active",
                        offset: $(".primary_nav_wrap").innerHeight() + mod,
                    });

                const observer = new MutationObserver(function (
                    mutationsList,
                    observer
                ) {
                    for (var i = 0; i < mutationsList.length; i++) {
                        if (
                            mutationsList[i].type === "attributes" &&
                            mutationsList[i].attributeName === "class"
                        ) {
                            if (
                                $(".section.active .section-subLinks li.active")
                                    .length <= 0
                            ) {
                                $(
                                    ".section.active .section-subLinks li:first-child"
                                ).addClass("active");
                            }
                        }
                    }
                });

                observer.observe(
                    document.querySelector(
                        ".section.active  .section-subLinks"
                    ),
                    {
                        attributes: true,
                        childList: true,
                        subtree: true,
                    }
                );
            }
        }
    },
    bindEvents: function () {
        $(".navigation .menu_toggle_mobile").on(
            "click",
            Navigation.events.toggleMenu
        );

        //on window resize
        Navigation.vars.$window.on("resize", function (e) {
            //automatically close the menu if transitioning to lg desktop
            Navigation.events.autoCloseMenu(e);
            if (
                (MQ.LG.matches && Navigation.vars.isMobile === true) ||
                (!MQ.LG.matches && Navigation.vars.isMobile === false)
            ) {
                Navigation.vars.isMobile = MQ.LG.matches ? false : true;

                Navigation.events.clearStickyNavs();

                Navigation.events.stickyNavs();

                if ($(".med_info_nav").hasClass("active")) {
                    $(".med_info_nav").removeClass("active");
                }
            } else if ($(".menu_set").hasClass("expanded")) {
                Navigation.events.setMenuHeight();
            }
            Navigation.vars.isMobile = MQ.LG.matches ? false : true;
        });

        Navigation.events.stickyNavs();

        //mobile menu behavior on scroll
        Navigation.vars.$window.on("scroll", function (e) {});

        //desktop navigation submenu
        $(".menu_toggle, .menu_items a").on(
            "focus",
            Navigation.events.openSubnav
        );
        $(".menu_toggle, .menu_items a").on(
            "blur",
            Navigation.events.closeLastSubnav
        );
        $(".menu").on("mouseout", Navigation.events.closeSubnav);

        //mobile navigation submenu
        $(".menu_toggle").on("click", function () {
            const $menuItems = $(this).next(".menu_items");

            if ($menuItems.hasClass("close_menu_items")) {
                // If menu is closed, open it
                Navigation.events.openSubnavMobile.call(this);
            } else {
                // If menu is open, close it
                Navigation.events.closeSubnavMobile.call(this);
            }
        });

        //med info menu
        $(".med_info_toggle").on("click", Navigation.events.toggleMedInfo);

        //scrolling button
        document
            .querySelector("button.scroller")
            .addEventListener("click", Navigation.events.scrollButtonEvent);

        //tertiary nav auto scroll
        $(".section-tertiaryLinks a").on(
            "click",
            Navigation.events.sideMenuScroll
        );
        $(
            "#treatmentGuidelines .section-subLinks a, #pro .section-subLinks a, #dosing-and-administration .section-subLinks a, #faqs .section-subLinks a"
        ).on("click", Navigation.events.sideMenuScroll);

        // TODO: This element might not exist anymore
        $("a.os-data").on("click", Navigation.events.sideMenuScroll);
    },
    events: {
        stickyNavs: function () {
            //desktop
            if (Navigation.vars.isMobile === false) {
                const utilityNavWrapHeight =
                    $(".utility_nav_wrap").innerHeight();

                $(".primary_nav_wrap")
                    .affix({
                        offset: {
                            top:
                                utilityNavWrapHeight +
                                $(".top_indication").innerHeight(),
                        },
                    })
                    .on("affixed.bs.affix", function (e) {
                        if (MQ.LG.matches) {
                            Navigation.vars.$body.addClass("nav_affix_primary");
                            Navigation.vars.$body.removeClass(
                                "nav_affix_wrapper"
                            );
                            if ($(".med_info_nav").hasClass("active")) {
                                $(".med_info_nav").removeClass("active");
                            }
                        }
                    })
                    .on("affix-top.bs.affix", function (e) {
                        if (MQ.LG.matches) {
                            Navigation.vars.$body.removeClass(
                                "nav_affix_primary"
                            );
                            Navigation.vars.$body.removeClass(
                                "nav_affix_wrapper"
                            );
                        }
                    });

                $(".logo_nav_wrap, .isi_nav_wrap").affix({
                    offset: {
                        top: utilityNavWrapHeight,
                    },
                });

                $(".strip").affix({
                    offset: {
                        top:
                            utilityNavWrapHeight +
                            $(".top_indication").innerHeight(),
                    },
                });

                $(".side-nav").affix({
                    offset: {
                        top: utilityNavWrapHeight,
                        bottom: function () {
                            return (this.bottom =
                                $("#footer").outerHeight(true) + 20);
                        },
                    },
                });

                /*$('.scroller').affix({
                            offset: {
                                bottom: function () {
                                    if (MQ.LG.matches) {
                                        return (this.bottom = 120);
                                    } else {
                                        return (this.bottom = $('#footer').outerHeight(true) + 20)
                                    }
                                }
                            }
                        })*/

                /*CORRECTS AFFIX ON SCROLL FOR LOGO AND SIDENAV*/
                $(window).on("scroll", function () {
                    if (MQ.LG.matches) {
                        $(".logo_nav_wrap").affix("checkPosition");
                    }
                    $("#footer").outerHeight();
                    $(".side-nav").affix("checkPosition");
                    const windowHeight = $("body").innerHeight();
                });

                /*CORRECTS AFFIX ON WINDOW RESIZE FOR SIDENAV */
                $(window).resize(function () {
                    $(".side-nav").affix("checkPosition");
                });

                $(window).trigger("scroll");
            }

            //mobile
            if (Navigation.vars.isMobile === true) {
                let wrapTop = $(".nav_wrapper").innerHeight();

                if ($(".top_indication").length > 0) {
                    wrapTop += $(".top_indication").innerHeight();
                }
            }
            //clear almost_top if actually at top
            if (Navigation.vars.$window.scrollTop() === 0) {
                Navigation.vars.$body.removeClass("almost_top");
            }
        },

        clearStickyNavs: function () {
            const affixSelectors = "affix affix-top affix-bottom nav_show_down";
            Navigation.vars.$window.off(".affix");

            $(".primary_nav_wrap")
                .removeData("bs.affix")
                .removeClass(affixSelectors);
            $(".nav_wrapper")
                .removeData("bs.affix")
                .removeClass(affixSelectors);

            Navigation.vars.$body.removeClass("nav_affix_wrapper");
            Navigation.vars.$body.removeClass("nav_affix_primary");
            Navigation.vars.$body.removeClass("almost_top");
        },

        toggleMenu: function () {
            const $menuSet = $(".navigation .menu_set");

            if ($menuSet.hasClass("expanded")) {
                $(this).removeClass("is-active");
                Navigation.events.closeMenu();
            } else {
                $(this).addClass("is-active");
                Navigation.events.openMenu();
            }
        },

        openMenu: function () {
            Navigation.vars.scrollTop = $(window).scrollTop();
            //$("body,html").addClass("noscroll");

            //Navigation.events.setMenuHeight();

            /*
            $(".navigation .menu_set").css(
                "height",
                Navigation.vars.$window.innerHeight() -
                    ($(".utility_nav_wrap").innerHeight() +
                        $(".top_indication").innerHeight()) +
                    "px"
            );
            */

            $(".nav_wrapper").show(0).addClass("menu_expanded");
            $(".navigation .menu_set").show(0).addClass("expanded");

            Navigation.vars.$body.addClass("menu_expanded");
        },

        closeMenu: function () {
            $("body,html").removeClass("noscroll");
            //window.scrollTo(0, Navigation.vars.scrollTop);
            Navigation.vars.$body.removeClass("menu_expanded");
            $(".nav_wrapper").removeClass("menu_expanded");
            var $menuSet = $(".navigation .menu_set");
            $menuSet.removeClass("expanded");
            //$(".navigation .menu_set").css("height", "");
            setTimeout(function () {
                $menuSet.hide(0);
            }, 200);
        },

        autoCloseMenu: function () {
            const $menuSet = $(".navigation .menu_set");

            if (MQ.LG.matches && $menuSet.hasClass("expanded")) {
                $(".menu_toggle_mobile").removeClass("is-active");
                Navigation.events.closeMenu();
            }
        },

        setMenuHeight: function () {
            $(".navigation .menu_set").css(
                "height",
                Navigation.vars.$window.innerHeight() -
                    ($(".utility_nav_wrap").innerHeight() +
                        $(".top_indication").innerHeight()) +
                    "px"
            );
        },

        updateScrollDirection: function () {
            // If element is scrolled into view, fade it in
            const scrollTop = Navigation.vars.$window.scrollTop();
            const direction =
                scrollTop >= Navigation.vars.lastScrollPosition ? "down" : "up";
            Navigation.vars.lastScrollPosition = scrollTop;
            Navigation.vars.scrollDirection = direction;
        },

        openSubnavMobile: function (e) {
            $(this).next(".menu_items").removeClass("close_menu_items");
            $(this).removeClass("rotate-arrow");
            $(this).addClass("arrow");
        },

        openSubnav: function (e) {
            $(".navigation .menu").removeClass("open");
            $(this).parents(".menu").addClass("open");
        },

        closeSubnavMobile: function (e) {
            $(this).next(".menu_items").addClass("close_menu_items");
            $(this).removeClass("arrow");
            $(this).addClass("rotate-arrow");
        },

        closeSubnav: function (e) {
            const $this = $(this);
            $this.removeClass("open");
            $this.find(".menu_toggle").blur();
        },

        closeLastSubnav: function (e) {
            const $this = $(this);
            if ($this.parents("li").is(":last-child")) {
                $this.parents(".menu").removeClass("open");
            }
        },

        goToAnchorOnLoad: function () {
            console.log("goToAnchorOnLoad");

            setTimeout(function () {
                const targetElement = document.getElementById(
                    Navigation.vars.anchorTarget
                );

                if (!targetElement) {
                    return;
                }

                Navigation.vars.lockMobileMenu = true;
                AnchorScroll.scrollToAnchor(
                    targetElement,
                    function () {
                        $(".nav_wrapper").removeClass("nav_show_down");
                        Navigation.vars.lockMobileMenu = false;

                        if (Navigation.vars.anchorTarget === "buttons") {
                            //trigger study design
                            $(
                                "#" +
                                    Navigation.vars.anchorTarget +
                                    " .designModal"
                            ).click();
                        }
                    },
                    {
                        behavior: "auto",
                    }
                );
            }, 10);
        },

        toggleMedInfo: function (e) {
            $(".med_info_nav").toggleClass("active");
        },

        scrollButtonEvent: function (e) {
            const $window = $(window);
            console.log("scrollButtonEvent");

            //scroll down
            if (
                Math.ceil($window.scrollTop()) <
                $(document).innerHeight() - window.innerHeight
            ) {
                $("html, body").animate(
                    {
                        scrollTop:
                            $window.scrollTop() + window.innerHeight * 0.4,
                    },
                    "fast",
                    "swing"
                );
            } else {
                //back to top
                $("html, body").animate(
                    {
                        scrollTop: 0,
                    },
                    "fast",
                    "swing"
                );
            }
        },

        sideMenuScroll: function (e) {
            const mod = -10;
            const $target = $($(this).attr("href"));

            e.preventDefault();
            $("html, body").animate(
                {
                    scrollTop:
                        $($target).offset().top -
                        $(".primary_nav_wrap").innerHeight() -
                        mod,
                },
                {
                    duration: 1500,
                    step: function (now, fx) {
                        var newOffset =
                            $($target).offset().top -
                            $(".primary_nav_wrap").innerHeight() -
                            mod;

                        if (fx.end !== newOffset) fx.end = newOffset;
                    },
                }
            );
        },
    },
};

//------------------------------------------------------------------------------------------------------------------
// ::: PRIVATE FUNCTIONS
//------------------------------------------------------------------------------------------------------------------

//------------------------------------------------------------------------------------------------------------------
// ::: CALLBACKS & EVENT HANDLERS
//------------------------------------------------------------------------------------------------------------------

//------------------------------------------------------------------------------------------------------------------
// ::: API
//------------------------------------------------------------------------------------------------------------------

export { Navigation };
